module.exports = __webpack_public_path__ + "static/media/color_blind_image_5.6ab70c7f.jpg";